import { create } from 'zustand';

export default create((set) => ({
    state: null,
    setState: (state) => set(() => ({ state })),
}));
